<div #map id="map" style="height: 400px; width: 100%"></div>
